import { ValidationService } from 'aspnet-validation';

//Create validation service
let v = new ValidationService();
window['aspnetValidation'] = v;

//Declare and register any custom validators - Begin
const mustbetrue = function (value, element, params) {
    //console.log(element);
    if (element.type && element.type === 'checkbox') {
        return element.checked;
    }
    return !value;
};
v.addProvider("mustbetrue", mustbetrue);

const requiredif = function (value, element, params) {
    const { dependentproperty, targetvalue } = params;
    let isValid = false;
    let targetElements = document.getElementsByName(dependentproperty);
    if (targetElements && targetElements.length > 0) {
        targetElements.forEach((el) => {
            if (el.type && (el.type === 'radio' || el.type === "checkbox")) {
                if (el.checked && el.value !== targetvalue) {
                    isValid = true;
                }
            }
        });
    } else {
        let targetElement = document.getElementById(dependentproperty);
        if (!targetElement || targetElement.value !== targetvalue) {
            isValid =  true;
        }
    }

    return isValid ? isValid : Boolean(value);
};

v.addProvider("requiredif", requiredif);
//Declare and register any custom validators - End

//Initialize
v.bootstrap();